module.exports = __webpack_public_path__ + "img/workspace-report-v2.5437cd1e.webp";